import { simpleSet } from '@r/reducers/utils';

const setItemsModalVisible = simpleSet as
  redux.reducers.flags.itemsModalVisible;

export const itemsModalVisible = setItemsModalVisible(
  'SET_ITEMS_MODAL_VISIBLE',
  false
);
